import axios from "axios";

import config from "../config/config";
import { buildHeaders } from "./buildAuthHeaders";

const axiosOptions = {
  baseURL: config.apiHost,
  withCredentials: true,
};

const api = axios.create({ ...axiosOptions });
const apiBase = axios.create({ ...axiosOptions });

const requestParams = [
  (request) => {
    const baseHeaders = buildHeaders();

    // For multipart/form-data uploads (FormData body), don't force a
    // Content-Type — axios/the browser must generate one that includes the
    // correct multipart boundary. Forcing application/json strips the
    // boundary and the server can't parse the stream (req.file ends up
    // undefined and the JSON body parser silently swallows the binary body).
    if (
      typeof FormData !== "undefined" &&
      request.data instanceof FormData
    ) {
      delete baseHeaders["Content-Type"];
    }

    request.headers = {
      ...request.headers,
      ...baseHeaders,
    };

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
];

api.interceptors.request.use(...requestParams);
apiBase.interceptors.request.use(...requestParams);

export const apiWithoutInterceptors = apiBase;

api.interceptors.response.use(
  (response) => response?.data,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/signin"; // Redirect to /signin on 401
    }
    return Promise.reject(error);
  }
);

export default api;
